import React, { useState } from "react";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  if (!isOpen) return null;

  const handleClick = async () => {
    setIsDeleting(true);
    await onConfirm(); // Execute the delete function
    setIsDeleting(false); // Optional: Re-enable after deletion
    onClose(); // Close the modal after deleting
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg">
        <h2 className="text-lg font-semibold mb-4">
          Are you sure you want to delete this field?
        </h2>
        <div className="flex justify-end gap-4">
          <button
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 rounded ${
              isDeleting ? "bg-gray-400 cursor-not-allowed" : "bg-red-500"
            } text-white`}
            onClick={handleClick}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
